import { useI18n } from "../i18n";
import { Hourglass, Zap, Timer } from "lucide-react";

export const creditsLeft = (user) => (user?.trial?.active ? user.trial.credits_today : 0) + (user?.subscription?.active ? user.subscription.credits_left : 0) + (user?.credits || 0);

export const TrialCard = ({ user }) => {
  const { t, date } = useI18n();
  const tr = user?.trial;
  if (!user) {
    return (
      <div className="panel p-6 sm:p-8 grid gap-4 trial-card" data-testid="trial-card">
        <span className="label text-amber flex items-center gap-2"><Hourglass size={13} /> {t("trialTitle")}</span>
        <p className="font-heading text-2xl font-black">{t("trialDays")}</p>
        <ul className="grid gap-2 text-sm text-muted">
          <li className="flex items-center gap-2"><Zap size={14} className="text-cyan" /> {t("trialDaily")}</li>
          <li className="flex items-center gap-2"><Timer size={14} className="text-cyan" /> {t("trialMinutes")}</li>
        </ul>
      </div>
    );
  }
  if (!tr) return null;
  const ends = date(new Date(tr.ends_at).getTime() - 1);
  return (
    <div className="panel p-6 sm:p-8 grid sm:grid-cols-[1fr_auto] gap-6 items-center trial-card" data-testid="trial-card">
      <div className="grid gap-3">
        <span className="label text-amber flex items-center gap-2"><Hourglass size={13} /> {t("trialTitle")}</span>
        {tr.active ? (
          <>
            <p className="font-heading text-2xl font-black" data-testid="trial-day">{t("trialDay", { d: tr.day, n: tr.days })}</p>
            <ul className="grid gap-1 text-sm text-muted">
              <li className="flex items-center gap-2"><Zap size={14} className="text-cyan" /> {t("trialDaily")}</li>
              <li className="flex items-center gap-2"><Timer size={14} className="text-cyan" /> {t("trialMinutes")}</li>
              <li className="flex items-center gap-2"><Hourglass size={14} className="text-cyan" /> {t("trialEnds", { date: ends })}</li>
            </ul>
            <div className="h-1.5 bg-[#242A38] w-full max-w-sm"><div className="h-full bg-amber" style={{ width: `${(tr.day / tr.days) * 100}%` }} /></div>
          </>
        ) : (
          <>
            <p className="font-heading text-2xl font-black" data-testid="trial-ended">{t("trialEnded")}</p>
            <p className="text-sm text-muted">{t("trialEndedText", { n: tr.days, date: ends })}</p>
          </>
        )}
      </div>
      {tr.active && (
        <div className="text-right">
          <p className="font-mono font-black text-5xl text-amber glow-amber" data-testid="trial-credits-today">{tr.credits_today}</p>
          <p className="label">{t("creditsToday")}</p>
        </div>
      )}
    </div>
  );
};
